import { AnimationFunction } from '../../../helpers/animation/animation-function';
import { getWindowScrollTop } from '../../../helpers/dom/get-window-scroll-top';

export function scrollTo(
	distance: number,
	animationFunction: AnimationFunction = (t, b, c, d) => (c * t) / d + b,
	duration = 300,
	wrapper: HTMLElement | Window = window
) {
	let start = getWindowScrollTop();
	let timeStart: number;
	let timeElapsed: number;

	if (wrapper instanceof HTMLElement) {
		start = wrapper.scrollTop;
	}

	requestAnimationFrame.call(window, (time) => {
		timeStart = time;
		loop(time);
	});

	function loop(time) {
		timeElapsed = time - timeStart;

		if (wrapper instanceof Window) {
			wrapper.scrollTo(
				0,
				animationFunction(timeElapsed, start, distance, duration)
			);

			if (timeElapsed < duration) {
				requestAnimationFrame.call(window, loop);
			} else {
				wrapper.scrollTo(0, start + distance);
			}
		} else {
			wrapper.scrollTop = animationFunction(
				timeElapsed,
				start,
				distance,
				duration
			);

			if (timeElapsed < duration) {
				requestAnimationFrame.call(window, loop);
			} else {
				wrapper.scrollTop = start + distance;
			}
		}
	}
}
